<template>
  <section v-on:click="sectionClicked" class="features">
    <div class="cnt">
      <div class="formCnt" :style="{'max-width': section.maxWidth}">
        <form v-on:submit.prevent="handleSubmit">
          <div class="rundown" v-if="section.items.length > 0">
            <div class="rundown-item-cnt">
              <div class="top-line"></div>
              <div class="rundown-item" v-for="(item, i) in section.items" :key="i">
                <div class="rundown-date">
                  {{item.from | moment(item.fromFormat)}}
                  <span class="min">-</span>
                  <span class="sd">
                    <template v-if="lang === 'id'">s/d</template>
                    <template v-if="lang === 'en'">to</template>
                  </span>
                  {{item.to | moment(item.toFormat)}}
                </div>
                <div class="rundown-info">
                  <h4 v-if="item.title[lang]">{{item.title[lang]}}</h4>
                  <div class="info-img" v-if="item.media[lang]">
                    <img :src="item.media[lang].imageMd">
                  </div>
                  <div class="info-desc" v-if="item.descriptions[lang]" v-html="item.descriptions[lang]"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="rundown" v-else>
            <div class="rundown-item-cnt">
              <div class="top-line"></div>
              <div class="rundown-item" v-for="i in 3" :key="i">
                <div class="rundown-date">
                  <div class="date-placeholder"></div>
                </div>
                <div class="rundown-info">
                  <div class="info-placeholder"></div>
                  <div class="info-placeholder infp2"></div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <ThankYou ref="thankYou"/>
  </section>
</template>

<script>
import ThankYou from '@/components/ThankYou.vue';

export default {
  name: 'home',
  props: ['section'],
  components: { ThankYou },
  data() {
    return {
      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {},
    resetForm() {
      // eslint-disable-next-line
      for (const item of this.section.items) {
        if (['select', 'dropdown'].includes(item.type)) {
          item.model[this.lang] = '__placeholder__';
        } else if (item.type === 'checkbox') {
          // eslint-disable-next-line
          for (const opt of item.options) {
            opt.selected = false;
          }
        } else {
          item.model[this.lang] = '';
        }
      }
    },
    handleSubmit() {
      const formData = {
        title: this.section.title,
        descriptions: this.section.descriptions,
        emailVerification: this.section.config.emailVerification,
        lang: this.lang,
        items: [],
      };
      // eslint-disable-next-line
      for (const item of this.section.items) {
        if (item.isRequired) {
          if (['select', 'dropdown'].includes(item.type)) {
            if (!item.model[this.lang] || item.model[this.lang] === '__placeholder__') {
              item.error.id = 'Pilihan harus dipilih';
              item.error.en = 'Field is required';
              return;
            }
          } else if (item.type === 'checkbox') {
            let hasSelected = false;
            // eslint-disable-next-line
            for (const opt of item.options) {
              if (opt.selected) hasSelected = true;
            }
            if (!hasSelected) {
              item.error.id = 'Pilihan harus dipilih';
              item.error.en = 'Field is required';
              return;
            }
          } else if (!item.model[this.lang] || item.model[this.lang].trim() === '') {
            item.error.id = 'Masukan harus diisi';
            item.error.en = 'Field is required';
            return;
          }
        }

        formData.items.push({
          type: item.type,
          isRequired: item.isRequired,
          label: item.label[this.lang],
          model: item.model[this.lang],
          placeholder: item.placeholder[this.lang],
          options: item.options,
        });
      }
      this.$refs.thankYou.open({
        loading: true,
        title: this.section.config.thankYouTitle[this.lang],
        desc: this.section.config.thankYouDesc[this.lang],
      });
      this.$http.post(this.$config.uri('user/form/submit'), formData).then((r) => {
        this.$refs.thankYou.stopLoading();
        this.resetForm();
      });
    },
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';

    // eslint-disable-next-line
    for (const item of this.section.items) {
      if (['select', 'dropdown'].includes(item.type) && item.placeholder[this.lang]) {
        item.model[this.lang] = '__placeholder__';
      }
    }
  },
};
</script>

<style scoped lang="scss">
.formCnt{
  margin: 0 auto;
  text-align: left;
}
.rundown{
  margin: 34px 0;
  .rundown-item-cnt{
    position: relative;
    &:before{
      content: "";
      position: absolute;
      left: 146px; height: 30px;
      bottom: -30px;
      width: 1px;
      background-color: #555;
      @media (max-width: 740px) {
        left: 78px;
      }
    }
    &:after{
      content: "";
      position: absolute;
      left: 146px; height: 30px;
      bottom: -30px;
      width: 1px;
      z-index: 3;
      background-image: linear-gradient(transparent, #fff);
      @media (max-width: 740px) {
        left: 78px;
      }
    }
    .top-line{
      &:before{
        content: "";
        position: absolute;
        left: 146px; height: 30px;
        top: -30px;
        width: 1px;
        background-color: #555;
        @media (max-width: 740px) {
          left: 78px;
        }
      }
      &:after{
        content: "";
        position: absolute;
        left: 146px; height: 30px;
        top: -30px;
        width: 1px;
        z-index: 3;
        background-image: linear-gradient(#fff, transparent);
        @media (max-width: 740px) {
          left: 78px;
        }
      }
    }
  }
  .rundown-item{
    display: flex;
    text-align: left;
    line-height: 1.4;
    .rundown-date{
      font-size: 20px;
      font-weight: 600;
      width: 146px;
      line-height: 1;
      padding: 10px 0 0;
      position: relative;
      box-sizing: border-box;
      .date-placeholder{
        background-color: #eee;
        border-radius: 3px;
        height: 20px;
        width: 80%;
        display: inline-block;
      }
      .sd{
        display: none;
      }
      @media (max-width: 740px) {
        text-align: center;
        padding-bottom: 10px;
        width: 78px;
        padding-right: 20px;
        .sd{
          display: block;
          font-weight: 400;
          font-size: 16px;
          margin: 2px 0;
        }
        .min{
          display: none;
        }
      }
      &:before{
        content: "";
        position: absolute;
        right: -5px; top: 16px; width: 9px; height: 9px;
        background-color: #555;
        border-radius: 50%;
      }
    }
    .rundown-info{
      width: calc(100% - 146px);
      padding: 10px 0 24px 30px;
      border-left: #555 1px solid;
      box-sizing: border-box;
      .info-placeholder{
        background-color: #eee;
        border-radius: 3px;
        height: 20px;
        margin: 0 0 6px;
        &.infp2{
          height: 12px;
          width: 70%;
          margin: 0;
        }
      }
      h4{
        margin: -2px 0 6px;
        font-size: 20px;
        font-weight: 600;
      }
      .info-desc{
        font-size: 16px;
        line-height: 1.3;
      }
      .info-img{
        margin: 0 0 10px;
        max-width: 240px;
        img{
          max-width: 100%;
          display: block;
          border-radius: 7px;
        }
      }
      @media (max-width: 740px) {
        width: calc(100% - 78px);
        padding-left: 20px;
      }
    }
  }
}
</style>
